module.exports = __webpack_public_path__ + "static/media/translate.1d13cbdf.png";